module.exports = __webpack_public_path__ + "media/icons/gallery-prev@2x-2aa1c9ae.png";